// TODO FIXIT: убрать посторения - следовать DRY

export const SET_MUNICIPALITY = 'setMunicipality';
export const SET_LOADING = 'setLoading';
export const SET_AGREE_COOKIE = 'setAgreeCookie';
export const SET_NEW_PDP_CONSENT_MODAL_VISIBLE = 'setNewPdpConsentModalVisible';

const mutations = {
  setDefaultLayout(state, payload) {
    state.defaultLayout = payload;
  },
  [SET_MUNICIPALITY](state, payload) {
    state.municipality = payload ? payload : null;
  },

  [SET_LOADING](state, payload) {
    state.loading = payload ? payload : false;
  },

  [SET_AGREE_COOKIE](state, payload) {
    state.agreeWithTheCookie = payload ? payload : false;
  },

  [SET_NEW_PDP_CONSENT_MODAL_VISIBLE](state, payload) {
    state.newPdpConsentModalVisible = !!payload;
  },

  setMenuStatus(state, payload) {
    state.menuOpen = payload;
  },

  setEducationForms(state, payload) {
    state.educationForms = payload;
  },

  setFinancingSource(state, payload) {
    state.financingSource = payload;
  },

  setEducationModes(state, payload) {
    state.educationModes = payload;
  },

  setEducationCategories(state, payload) {
    state.educationCategories = payload;
  },

  setEducationFormData(state, payload) {
    state.educationForm = payload;
  },

  setActivityMembers(state, payload) {
    state.activityMembers = payload;
  },

  setActivityLevels(state, payload) {
    state.activityLevels = payload;
  },

  setActivitySections(state, payload) {
    state.activitySections = payload;
  },

  setModulesSections(state, payload) {
    state.modulesSections = payload;
  },

  setDepartments(state, payload) {
    state.departments = payload;
  },

  setApiModules(state, payload) {
    state.apiModules = payload;
  },

  setRegions(state, payload) {
    state.regions = payload;
  },

  setOrganizators(state, payload) {
    state.organizators = payload;
  },
  setOrganizatorsFullList(state, payload) {
    state.organizatorsFullList = payload;
  },

  setUserRoles(state, payload) {
    state.roles = payload;
  },

  setUserEduLevel(state, payload) {
    state.eduLevels = payload;
  },

  setUserConsultationsTopic(state, payload) {
    state.consultationsTopics = payload;
  },

  setProfSpheres(state, payload) {
    state.profSpheres = payload;
  },

  setProfessions(state, payload) {
    state.professions = payload;
  },

  setCompetences(state, payload) {
    state.competences = payload;
  },

  setOrderCancelReasonDict(state, payload) {
    state.orderCancelReasonDict = payload;
  },
  setMultiCop(state, payload) {
    state.copMultiDict = payload;
  },
  setOrganizations(state, payload) {
    state.organizationsDict = payload;
  },
  setProgrammTypes(state, payload) {
    state.programmTypes = payload;
  },

  // Временное решение, оптимизировать, переделать
  setUnpublishedProfSpheres(state, payload) {
    state.unpublishedProfSpheres = payload;
  },

  setUnpublishedProfessions(state, payload) {
    state.unpublishedProfessions = payload;
  },

  setUnpublishedCompetences(state, payload) {
    state.unpublishedCompetences = payload;
  },
  // конец решения

  setIndustries(state, payload) {
    state.industries = payload;
  },

  setRegionProfile(state, payload) {
    state.regionProfile = payload;
  },

  setCrumbs(state, payload) {
    state.crumbs = payload;
  },

  setMainNav(state, payload) {
    state.mainNav = payload;
  },

  setSections(state, payload) {
    state.sections = payload;
  },

  setMunicipalities(state, payload) {
    state.municipalities = payload;
  },

  setMunicipalityRegions(state, payload) {
    state.municipalityRegions = payload;
  },

  // setOrganizators(state, payload) {
  //   state.organizators = payload;
  // },

  setEventTypes(state, payload) {
    state.eventTypes = payload;
  },

  setFooterNav(state, payload) {
    state.footerNav = payload;
  },

  setPfdodDiseases(state, payload) {
    state.dictionaryDisease = payload;
  },

  setNokoCompetitionLevels(state, payload) {
    state.nokoCompetitionLevels = payload;
  },

  setNokoCompetitionList(state, payload) {
    state.nokoCompetitionList = payload;
  },

  setNokoCompetitionTypes(state, payload) {
    state.nokoCompetitionTypes = payload;
  },

  addNokoCompetitionList(state, payload) {
    state.nokoCompetitionList.push(payload);
  },

  setNokoProgressResult(state, payload) {
    state.nokoProgressResult = payload;
  },

  setQuestionnaireForm(state, payload = []) {
    state.nokoQuestionnaireForm = payload;
  },

  setIsTokensExist(state, payload) {
    state.isTokensExist = payload;
  },

  setWorkTypesData(state, payload) {
    state.workTypes = payload;
  },

  setSpheresTypesData(state, payload) {
    state.workSpheres = payload;
  },

  setProfStandarts(state, payload) {
    state.profStandarts = payload;
  },

  setWorkPlaces(state, payload) {
    state.workPlaces = payload;
  },

  setPayLevels(state, payload) {
    state.payLevels = payload;
  },

  setEducationLevels(state, payload) {
    state.educationLevels = payload;
  },

  setEducationLevelDict(state, payload) {
    state.educationLevelDict = payload;
  },

  setEducationTypeDict(state, payload) {
    state.educationTypeDict = payload;
  },

  setDriverLicenseDict(state, payload) {
    state.driverLicenseDict = payload;
  },

  setLanguageLevelDict(state, payload) {
    state.languageLevelDict = payload;
  },

  setWorldLanguageDict(state, payload) {
    state.worldLanguageDict = payload;
  },

  setCompetencesList(state, payload) {
    state.competencesList = payload;
  },

  setCompetencesListCount(state, payload) {
    state.competencesListCount = payload;
  },

  setCompetencesBlocks(state, payload) {
    state.competencesBlocks = payload;
  },
  setRegionsDict(state, payload) {
    state.regionsDict = payload;
  },
  setBlogEventsDict(state, payload) {
    state.blogEventsDict = payload;
  },
  setEventOrderEduLevelsDict(state, payload) {
    state.eventOrderEduLevelsDict = payload;
  },
  setWorkScheduleDataDict(state, payload) {
    state.workScheduleDataDict = payload;
  },
  setEmploymentDict(state, payload) {
    state.employmentDataDict = payload;
  },
  setPartnerRoleDict(state, payload) {
    state.partnerRoleDict = payload;
  },
  setActivityOrderEduLevelDict(state, payload) {
    state.activityOrderEduLevelDict = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js